const buildRoundedSumExpr = (keys: string[], decimalPlaces: number) => {
  if (!keys.length) {
    return undefined;
  }
  const roundedTerms = keys.map(key => `round(${key},${decimalPlaces})`).join(',');
  return `=sum(${roundedTerms})`;
};

export default buildRoundedSumExpr;
